export function fetchRequestFeedback(data) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
        "token": data.token,
        "object": data.object,
        "text": data.text,
        "contactPhone": data.contactPhone,
        "city": data.city,
        "name": data.name
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return fetch("https://feedback.sespel.su/submit", requestOptions)
        .then((response) => response.text())
        .then((result) => result)
        .catch((error) => error)


}

export function fetchRequestMyRequests(token) {

    const myHeaders = new Headers();

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    return fetch(`https://feedback.sespel.su/request-by-token?my-token=${token}`, requestOptions)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => error)


}
